/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nimble_Shy_Nils_StabInputs */

const fr_nimble_shy_nils_stab = /** @type {(inputs: Nimble_Shy_Nils_StabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket`)
};

/**

* @param {Nimble_Shy_Nils_StabInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const nimble_shy_nils_stab = /** @type {((inputs?: Nimble_Shy_Nils_StabInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nimble_Shy_Nils_StabInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_nimble_shy_nils_stab(inputs)
});